import { Modal } from "@devhop/ui";
import { QUOTATION_INVOICE_DOCUMENT_TYPE_LABELS } from "@/modules/quotation-invoice/domain/document-type";
import { useQuotationInvoiceDocumentTypesQuery } from "../api/queries";

/**
 * ປະເພດເອກະສານຖືກກຳນົດໂດຍ enum (quotation → invoice → receipt) — ບໍ່ມີການເພີ່ມ/ແກ້ໃນຖານຂໍ້ມູນ
 */
export function DocumentTypeManagementModal({
  open,
  onOpenChange,
  onRefresh,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onRefresh?: () => void;
}) {
  const { data: typesData, refetch } = useQuotationInvoiceDocumentTypesQuery({
    limit: 200,
    includeInactive: true,
  });
  const types = typesData?.items ?? [];

  const handleOpenChange = (next: boolean) => {
    onOpenChange(next);
    if (!next) {
      void refetch();
      onRefresh?.();
    }
  };

  return (
    <Modal
      open={open}
      onOpenChange={handleOpenChange}
      title="ປະເພດເອກະສານ (ຄົງທີ່)"
      size="lg"
    >
      <p className="text-muted-foreground text-sm">
        ລະບົບໃຊ້ສາມປະເພດ: {QUOTATION_INVOICE_DOCUMENT_TYPE_LABELS.quotation} →{" "}
        {QUOTATION_INVOICE_DOCUMENT_TYPE_LABELS.invoice} →{" "}
        {QUOTATION_INVOICE_DOCUMENT_TYPE_LABELS.receipt} —
        ສາມາດແປງຕໍ່ກັນໃນເວລາດຳເນີນງານ (ບໍ່ສາມາດເພີ່ມປະເພດໃໝ່ໃນຖານຂໍ້ມູນ)
      </p>
      <div className="mt-4 rounded-lg border">
        <div className="max-h-[calc(100vh-16rem)] overflow-y-auto">
          {types.length === 0 ? (
            <div className="p-4 text-center text-muted-foreground text-sm">
              ກຳລັງໂຫຼດ...
            </div>
          ) : (
            <div className="divide-y">
              {types.map((type) => (
                <div
                  key={type.id}
                  className="flex items-center justify-between gap-2 p-4"
                >
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <span className="font-medium">{type.name}</span>
                      <span className="rounded bg-muted px-1.5 py-0.5 text-muted-foreground text-xs">
                        {type.code}
                      </span>
                    </div>
                    <div className="text-muted-foreground text-sm">
                      ລຳດັບ: {type.orderIndex}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}
